import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';
import LogInModal from 'flarum/forum/components/LogInModal';

import { EMOJI_CATEGORIES, EMOJI_INDEX } from '../emoji-data';
import { EMOJI_TRANSLATIONS } from '../emoji-i18n';

const _fold = (s) =>
  s
    .replace(/[\u0152\u0153]/g, 'oe')
    .replace(/[\u00c6\u00e6]/g, 'ae')
    .replace(/\u00df/g, 'ss')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
const _searchCache = new Map();

function emojiSearchText(id) {
  let text = _searchCache.get(id);

  if (text === undefined) {
    const fr = EMOJI_TRANSLATIONS.fr[id];
    const pt = EMOJI_TRANSLATIONS.pt[id];
    text = _fold([id, fr, pt].filter(Boolean).join(' '));
    _searchCache.set(id, text);
  }

  return text;
}

export default class EmojiPostReactAction extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    this.post = vnode.attrs.post;

    this.loading = {};
    this.query = '';
    this.panelEl = null;
    this.closeTimer = null;

    this.updateChosenReaction();
  }

  oncreate(vnode) {
    super.oncreate(vnode);

    if ('ontouchstart' in window) {
      this.$()
        .unbind()
        .on('touchend', (e) => {
          if ($(e.target).closest('.CommentPost--Reactions, .Reactions--reactions').length) return;

          if (!this.panelEl) {
            this.showPicker();
            requestAnimationFrame(() => this.panelEl && this.panelEl.classList.add('mobile-show'));
          } else {
            this.hidePicker();
          }
        });
    }

    this.$()
      .on('mouseenter.reactions-picker', '.Reactions--react', () => {
        clearTimeout(this.closeTimer);
        this.showPicker();
      })
      .on('mouseleave.reactions-picker', '.Reactions--react', () => {
        clearTimeout(this.closeTimer);

        this.closeTimer = setTimeout(() => {
          this.hidePicker();
        }, 200);
      });

    $(document)
      .off('click.emojipicker')
      .on('click.emojipicker', (e) => {
        if (!$(e.target).closest('.Reactions').length) {
          $('.CommentPost--Reactions').removeClass('mobile-show');
          this.hidePicker();
        }
      });
  }

  onremove(vnode) {
    super.onremove(vnode);

    clearTimeout(this.closeTimer);
    this.$().off('.reactions-picker');
    this.hidePicker();
  }

  showPicker() {
    if (this.panelEl) return;

    const host = this.$().find('.Reactions--react').get(0);

    if (!host) return;

    const panel = document.createElement('div');
    panel.className = 'CommentPost--Reactions CommentPost--Reactions--all';

    if (this.post.number() !== 1) {
      panel.style.left = 'auto';
      panel.style.bottom = '100%';
      panel.style.top = 'auto';
    }

    host.appendChild(panel);

    this.panelEl = panel;
    this.renderPicker();
  }

  hidePicker() {
    if (!this.panelEl) return;

    m.render(this.panelEl, null);
    this.panelEl.remove();
    this.panelEl = null;
  }

  renderPicker() {
    if (this.panelEl) m.render(this.panelEl, this.picker());
  }

  categoryLabel(category) {
    return app.translator.trans(`florcarioca-emoji-all.forum.categories.${category.key}`);
  }

  cdnUrl(codePoint) {
    return app.forum.attribute('fofReactionsCdnUrl').replace('[codepoint]', codePoint);
  }

  reactionsById() {
    if (!this._reactionsById) {
      this._reactionsById = {};
      this._reactionsSortedId = [];

      app.forum.reactions().forEach((reaction) => {
        if (!reaction.enabled()) return;

        this._reactionsById[reaction.identifier()] = reaction;
      });
    }

    return this._reactionsById;
  }

  emoji(identifier) {
    const codePoint = EMOJI_INDEX[identifier];

    if (codePoint) {
      return <img className="emoji" src={this.cdnUrl(codePoint)} loading="lazy" draggable="false" alt={identifier} title={identifier} />;
    } else {
      return <i className={identifier} aria-hidden />;
    }
  }

  picker() {
    const query = _fold(this.query.trim());
    let categories = EMOJI_CATEGORIES;

    if (query) {
      categories = [
        {
          key: 'results',
          name: 'results',
          emojis: EMOJI_CATEGORIES.reduce((all, category) => {
            return all.concat(category.emojis.filter((emoji) => emojiSearchText(emoji.id).includes(query)));
          }, []).slice(0, 200),
        },
      ];
    }

    return (
      <div className="EmojiPickerPanel">
        <input
          className="FormControl EmojiPickerPanel-search"
          type="search"
          placeholder={app.translator.trans('florcarioca-emoji-all.forum.picker.search_placeholder')}
          value={this.query}
          oninput={(e) => {
            this.query = e.target.value;
            this.renderPicker();
          }}
        />

        <div className="EmojiPickerPanel-scroll">
          {categories.map((category) => (
            <div className="EmojiPickerPanel-category" key={category.name}>
              <div className="EmojiPickerPanel-categoryLabel">{this.categoryLabel(category)}</div>
              <div className="EmojiPickerPanel-grid">
                {category.emojis.map((emoji) => (
                  <button
                    className="EmojiPickerPanel-cell"
                    type="button"
                    title={emoji.id}
                    onclick={this.onEmojiClick.bind(this, emoji.id)}
                    data-reaction={emoji.id}
                  >
                    {this.emoji(emoji.id)}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  view() {
    const reactionCounts = this.post.reactionCounts();
    const canReact = this.post.canReact();

    const hasReacted = this.post.userReaction() && reactionCounts[this.post.userReaction()] > 0;

    return (
      <div style="margin-right: 7px" className="Reactions">
        <div className="Reactions--reactions">
          {Object.keys(reactionCounts).map((id) => {
            const reaction = app.store.getById('reactions', id);
            const count = reactionCounts[id];

            if (!reaction || count === 0) return;

            return Button.component(
              {
                className: `Button Button--flat Button-emoji-parent ${this.post.userReaction() == reaction.id() && 'active'}`,
                onclick: canReact ? this.react.bind(this, reaction) : undefined,
                'data-reaction': reaction.identifier(),
                disabled: !canReact,
                loading: this.loading[reaction.id()],
              },
              <span>
                {this.emoji(reaction.identifier())} {count > 1 ? <span className="count">{count}</span> : ''}
              </span>
            );
          })}
        </div>

        {(!Object.keys(this.loading).length || this.loading[null]) && !hasReacted && canReact && (
          <div className="Reactions--react">{this.reactButton()}</div>
        )}
      </div>
    );
  }

  reactButton() {
    return (
      <Button
        className="Button Button--link Reactions--ShowReactions"
        type="Button"
        title={app.translator.trans('fof-reactions.forum.react_button_label')}
        loading={this.loading[null]}
      >
        <span className="Button-label">
          <svg class="button-react" width="20px" height="20px" viewBox="0 0 18 18">
            <g id="Reaction" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="ic_reactions_grey">
                <g id="Group-2">
                  <g id="0:0:0:0">
                    <rect id="Rectangle-5" x="0" y="0" width="18" height="18" />
                    <g id="emoticon" />
                    <path
                      d="M14.6332705,7.33333333 C14.6554304,7.55389388 14.6666667,7.77636769 14.6666667,8 C14.6666667,11.6818983 11.6818983,14.6666667 8,14.6666667 C6.23189007,14.6666667 4.53619732,13.9642877 3.28595479,12.7140452 C2.03571227,11.4638027 1.33333333,9.76810993 1.33333333,8 C1.33333333,4.33333333 4.31333333,1.33333333 8,1.33333333 L8,1.33333333 C8.22363231,1.33333333 8.44610612,1.3445696 8.66666667,1.36672949 L8.66666667,2.70847693 C8.44668912,2.68076722 8.22407146,2.66666667 8,2.66666667 C5.05448133,2.66666667 2.66666667,5.05448133 2.66666667,8 C2.66666667,10.9455187 5.05448133,13.3333333 8,13.3333333 C10.9455187,13.3333333 13.3333333,10.9455187 13.3333333,8 C13.3333333,7.77592854 13.3192328,7.55331088 13.2915231,7.33333333 L14.6332705,7.33333333 Z M8,11.6666667 C9.55333333,11.6666667 10.8666667,10.6933333 11.4066667,9.33333333 L4.59333333,9.33333333 C5.12666667,10.6933333 6.44666667,11.6666667 8,11.6666667 Z M10.3333333,7.33333333 C10.8856181,7.33333333 11.3333333,6.88561808 11.3333333,6.33333333 C11.3333333,5.78104858 10.8856181,5.33333333 10.3333333,5.33333333 C9.78104858,5.33333333 9.33333333,5.78104858 9.33333333,6.33333333 C9.33333333,6.88561808 9.78104858,7.33333333 10.3333333,7.33333333 L10.3333333,7.33333333 Z M5.66666667,7.33333333 C6.21895142,7.33333333 6.66666667,6.88561808 6.66666667,6.33333333 C6.66666667,5.78104858 6.21895142,5.33333333 5.66666667,5.33333333 C5.11438192,5.33333333 4.66666667,5.78104858 4.66666667,6.33333333 C4.66666667,6.88561808 5.11438192,7.33333333 5.66666667,7.33333333 Z"
                      id="Combined-Shape"
                      fill="#667c99"
                    />
                  </g>
                  <g id="Group-15" transform="translate(10.666667, 0.000000)" fill="#667c99">
                    <polygon
                      id="Path"
                      points="3.33333333 2 3.33333333 0 2 0 2 2 0 2 0 3.33333333 2 3.33333333 2 5.33333333 3.33333333 5.33333333 3.33333333 3.33333333 5.33333333 3.33333333 5.33333333 2"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </span>
      </Button>
    );
  }

  onEmojiClick(identifier, e) {
    const reaction = this.reactionsById()[identifier];

    if (!reaction) return;

    this.react(reaction, e);
  }

  react(reaction, e) {
    if (e && e.target && e.target.blur) e.target.blur();

    const allowAnonymous = app.forum.attribute('fofReactionsAllowAnonymous');

    if (!app.session.user && !allowAnonymous) {
      app.modal.show(LogInModal);
      return;
    }

    if (!this.post.canReact()) {
      return app.alerts.show({ type: 'error' }, app.translator.trans('core.lib.error.permission_denied_message'));
    }

    const id = reaction.id();
    const originalPostReactions = this.post.reactionCounts();

    this.loading[id] = true;

    return this.post
      .save({ reaction: id })
      .then((post) => {
        delete this.loading[id];

        for (const reactionId in originalPostReactions) {
          if (!post.reactionCounts().hasOwnProperty(reactionId)) {
            app.store.remove(app.store.getById('reactions', reactionId));
          }
        }

        this.updateChosenReaction();
        this.hidePicker();

        m.redraw();
      })
      .catch((err) => {
        delete this.loading[id];

        $('body').append(err);

        m.redraw();
      });
  }

  updateChosenReaction() {
    return (this.reaction = this.post.userReaction());
  }
}